import React from 'react';
import './App.css';
import MainPage from "./ui/main/MainPage";

function App() {
  return (
    <MainPage />
  );
}

export default App;
